import { Pipe, PipeTransform } from '@angular/core';
import { ProductDetailViewModel } from '@models/api-search.models';
import { ActiveCampaign } from '@features/product/product.models';

@Pipe({
    name: 'campaignOnUse',
    standalone: true
})
export class CampaignOnUsePipe implements PipeTransform {
    transform(
        activeCampaigns: ProductDetailViewModel['activeCampaigns'],
        campaignOnUse?: string
    ): ActiveCampaign | undefined {
        return activeCampaigns?.find(campaign => campaign.campaignId === campaignOnUse);
    }
}
